/**
 * enum for setting block direction, used by setDirection API
 */
export const enum Direction {
    /**
     * Left to right
     */
    LeftToRight,

    /**
     * Right to left
     */
    RightToLeft,
}
